import React from "react";

interface SplitSVGProps extends React.SVGProps<SVGSVGElement> {
  direction?: string
  alternateFill?: string
}

export const Split = ({ direction, alternateFill, ...props }: SplitSVGProps) => (
  <svg width={30} height={30} xmlns="http://www.w3.org/2000/svg" {...props} style={{transform: direction == 'vertical' ? 'rotate(90deg)' : 'rotate(0deg)'}} key={direction}>
    <g
      fill="none"
      fillRule="evenodd"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M15.5 5.5h-10a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zM10.5 5.5v10" />
    </g>
  </svg>
)
